export const MAX_SIZE_LOGO = 1048576;
export const MAX_SIZE_IMAGE = 5242880;
export const MAX_NUMBER_IMG = 5;
